import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "~/providers/LanguageProvider";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import FilterToggleTopic from "../ListToggle/FilterToggleTopic";
import SearchDialogForm from "~/features/SearchV3/components/SearchDialog/SearchDialogForm";
import SearchDialogModal from "~/features/SearchV3/components/SearchDialog/SearchDialogModal";
import useSolrMetaData from "~/features/SearchV3/hooks/useSolrMetaData";
import { useLocation } from "react-router-dom";

const ImageThemes = () => {
    const { t } = useTranslation();
    const { language } = useContext(LanguageContext);
    const { isModalOpen } = useSolrMetaData();
    const location = useLocation();
    const { imageThemeFilters, setTriggerSearch } = useContext(AdvancedSearchContext);

    useEffect(() => {
        setTriggerSearch(true);
    }, [location.key]);

    const selectedCount = imageThemeFilters.length;
    const firstSelected =
        language === "fr" ? imageThemeFilters[0]?.frName || "" : imageThemeFilters[0]?.name || "";
    const remainingCount = selectedCount > 1 ? selectedCount - 1 : 0;

    const truncateText = (text: string, maxLength = 40) => {
        return text.length > maxLength ? text.slice(0, maxLength - 3) + "..." : text;
    };

    let displayLabel: string;

    if (selectedCount === 0) {
        displayLabel = t("topic");
    } else if (remainingCount === 0) {
        displayLabel = truncateText(firstSelected);
    } else {
        displayLabel = `${truncateText(firstSelected)} +${remainingCount} more`;
    }

    return (
        <FilterToggleTopic label={displayLabel} count={selectedCount} panelWidth={"max-w-sm"}>
            <SearchDialogModal open={isModalOpen}>
                <SearchDialogForm />
            </SearchDialogModal>
        </FilterToggleTopic>
    );
};

export default ImageThemes;
